const ROUTE_PATH = {
  PAGE404: '*',
  UN_AUTH: '/unauthorised',
  LOGIN: '/',
  VERIFY_OTP: '/verify-otp',
  HOSPICASH: '/hospicash-insurance',
  WELLNESS: '/wellness-services',
  COMPREHENSIVE: '/coversure-platform',
  DASHBOARD: '/dashboard',
  SUPPORT: '/support',
  TERM_CONDITION: '/terms-and-conditions',
  PAYMENT: '/payment',
  SUCCESS_PAYMENT: '/payment-success',
  FAILURE_PAYMENT: '/payment-failed',
};

export default ROUTE_PATH;
